import { FileTags, InstallationStatementModel } from '../models/statement'
import { DEFAULT_GUARANTEE, DEFAULT_WARRANTY, EXTENDED_WARRANTY } from './consts'
import { add } from 'date-fns'

/**
 * Calculate the end date of a system's warranty
 */
export const calculateWarrantyDate = (
  installationDate: Date | undefined,
  installationStatement: InstallationStatementModel | undefined
): Date | undefined => {
  if (!installationDate || !installationStatement) return undefined
  let warrantyDate = add(new Date(installationDate), { years: DEFAULT_WARRANTY })
  const hasExtendedWarranty = !!installationStatement?.files?.find(file => file.tag === FileTags.Warranty)

  if (hasExtendedWarranty) {
    warrantyDate = add(new Date(installationDate), { years: EXTENDED_WARRANTY })
  }

  return warrantyDate
}

/**
 * Calculate the end date of a system's guarantee
 * (Which is Gewährleistung in German and is different from warranty (Garantie))
 */
export const calculateGuaranteeDate = (installationDate: Date | undefined): Date | undefined => {
  if (!installationDate) return undefined
  return add(new Date(installationDate), { years: DEFAULT_GUARANTEE })
}
